<template>
    <div class="screen">
        <div class="header">
            <div class="h_title">益题库数据可视化大平台</div>
            <div class="h_time">
                <img src="https://www.yitku.com/screen/refresh.png" width="20px" height="20px"></img>
                数据更新时间 {{ jsonData.time }}
            </div>
        </div>

        <div class="b_body">
            <div class="b_left">
                <div class="qiu">

                    <div class="content1">
                        <div class="progress-box">
                            <div class="progress" :style="{ '--progress': `${progress}%` }"></div>
                            <div class="progress-value-p">
                                <div class="value">{{ jsonData.giga }}<span>TB</span></div>
                                <div class="text">课程总流量消耗</div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="hot">
                    <div class="four">
                        <div class="four1"></div>
                        <div class="four_body"></div>
                        <div class="four2"></div>
                    </div>
                    <div class="hot_title"><span></span>各项目实时热度排行榜</div>
                    <div class="hot_content">
                        <div class="hot_li" v-for="(item, index) in oneData" :key="index">
                            <div class="hot_jt">
                                <img src="https://www.yitku.com/screen/up.png" width="12px" height="18px"></img>
                            </div>
                            <div class="hot_name">{{ item.title }}</div>
                            <div class="hot_rang"><el-progress :text-inside="true" :stroke-width="10"
                                    :percentage="item.val" :color="item.color" :show-text="false" status="success"
                                    stroke-linecap="square" class="custom-circle"></el-progress>
                            </div>
                        </div>
                    </div>
                    <div class="four">
                        <div class="four3"></div>
                        <div class="four_body"></div>
                        <div class="four4"></div>
                    </div>
                </div>
                <div class="hot">
                    <div class="four">
                        <div class="four1"></div>
                        <div class="four_body"></div>
                        <div class="four2"></div>
                    </div>
                    <div class="hot_title"><span></span>项目流量消耗明细</div>
                    <div class="hot_uchartb">
                        <qiun-vue-ucharts type="column" :opts="opts" :chartData="chartData" />
                    </div>
                    <div class="four">
                        <div class="four3"></div>
                        <div class="four_body"></div>
                        <div class="four4"></div>
                    </div>
                </div>
            </div>
            <div class="b_center">
                <div class="b_title">服务访问总量</div>
                <div class="b_time">
                    <div class="b_li" v-for="(item, idx) in viewData" :key="idx">{{ item }}</div>
                </div>
                <div class="price">
                    <div class="b_nav">累计成交金额</div>
                    <div class="b_price">
                        <count-to :startVal="0" :endVal="jsonData.price" :duration="3000"></count-to>
                    </div>
                </div>
                <div class="u_list">
                    <div class="u_left">
                        <div class="u_img">
                            <img src="https://www.yitku.com/screen/user.png" width="86px" height="73px"></img>
                        </div>
                        <div class="u_text">
                            <div class="u_num"><count-to :startVal="0" :endVal="jsonData.users"
                                    :duration="3000"></count-to><span style="font-size: 12px;">人</span></div>
                            <div class="u_txt">累计用户量</div>
                        </div>
                    </div>
                    <div class="u_left">
                        <div class="u_img">
                            <img src="https://www.yitku.com/screen/user1.png" width="86px" height="73px"></img>
                        </div>
                        <div class="u_text">
                            <div class="u_num"><count-to :startVal="0" :endVal="jsonData.today"
                                    :duration="3000"></count-to><span style="font-size: 12px;">人</span></div>
                            <div class="u_txt">今日注册用户量</div>
                        </div>
                    </div>
                </div>

                <div class="cpu">
                    <div class="cpu_left">
                        <div class="cpu_chart">
                            <qiun-vue-ucharts type="gauge" :opts="opts_cup" :chartData="cpuData" />
                        </div>
                    </div>
                    <div class="cpu_right">
                        <div class="cpu_chart">
                            <qiun-vue-ucharts type="gauge" :opts="opts_memory" :chartData="memoryData" />
                        </div>
                    </div>
                </div>

            </div>
            <div class="b_left">
                <div class="hot">
                    <div class="four">
                        <div class="four1"></div>
                        <div class="four_body"></div>
                        <div class="four2"></div>
                    </div>
                    <div class="hot_title"><span></span>平台接口访问波动表</div>
                    <div class="hot_ucharts">
                        <qiun-vue-ucharts type="area" :opts="opts" :loadingType="1" :chartData="chartData2" />
                    </div>
                    <div class="four">
                        <div class="four3"></div>
                        <div class="four_body"></div>
                        <div class="four4"></div>
                    </div>
                </div>
                <div class="hot">
                    <div class="four">
                        <div class="four1"></div>
                        <div class="four_body"></div>
                        <div class="four2"></div>
                    </div>
                    <div class="hot_title"><span></span>各功能板块接口访问</div>
                    <div class="hot_ucharts">
                        <qiun-vue-ucharts type="area" :opts="opts" :chartData="chartData3" />
                    </div>
                    <div class="four">
                        <div class="four3"></div>
                        <div class="four_body"></div>
                        <div class="four4"></div>
                    </div>
                </div>
                <div class="hot">
                    <div class="four">
                        <div class="four1"></div>
                        <div class="four_body"></div>
                        <div class="four2"></div>
                    </div>
                    <div class="hot_title"><span></span>各项目试题总量排行榜</div>
                    <div class="hot_ucharts">
                        <qiun-vue-ucharts type="column" :opts="opts" :chartData="chartData4" />
                    </div>
                    <div class="four">
                        <div class="four3"></div>
                        <div class="four_body"></div>
                        <div class="four4"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="datai">
        </div>
    </div>
</template>


<script>
import countTo from "vue-count-to";
import AnimatedNumber from "@/components/AnimatedNumber";
import qiunVueUcharts from '@qiun/vue-ucharts';
export default {
    components: { countTo, AnimatedNumber, qiunVueUcharts },
    data() {
        return {
            progress: 45,
            isCollapse: false,
            jsonData: [],
            oneData: [],
            viewData: [],
            userTitle: "",
            startVal: 0,
            endVal: 0,
            onlineUsers: 0,
            salesToday: 0,
            chartData: {},
            chartData2: {},
            chartData3: {},
            chartData4: {},
            cpuData: {},
            memoryData: {},
            opts_cup: {
                color: ["#FF44F8", "#91CB74", "#FAC858", "#EE6666", "#73C0DE", "#3CA272", "#FC8452", "#9A60B4", "#ea7ccc"],
                padding: undefined,
                title: {
                    name: "0%",
                    fontSize: 22,
                    color: "#ffffff",
                    offsetY: 0
                },
                subtitle: {
                    name: "实时消耗",
                    fontSize: 12,
                    color: "#FF44F8",
                    offsetY: 0
                },
                extra: {
                    gauge: {
                        type: "progress",
                        width: 4,
                        labelColor: "#666666",
                        startAngle: 0.75,
                        endAngle: 0.25,
                        startNumber: 0,
                        endNumber: 100,
                        labelFormat: "",
                        splitLine: {
                            fixRadius: 0,
                            splitNumber: 10,
                            width: 15,
                            color: "#FFFFFF",
                            childNumber: 5,
                            childWidth: 5
                        },
                        pointer: {
                            width: 15,
                            color: "auto"
                        }
                    }
                }
            },
            opts_memory: {
                color: ["#FF44F8", "#91CB74", "#FAC858", "#EE6666", "#73C0DE", "#3CA272", "#FC8452", "#9A60B4", "#ea7ccc"],
                padding: undefined,
                title: {
                    name: "0%",
                    fontSize: 22,
                    color: "#ffffff",
                    offsetY: 0
                },
                subtitle: {
                    name: "实时消耗",
                    fontSize: 12,
                    color: "#FF44F8",
                    offsetY: 0
                },
                extra: {
                    gauge: {
                        type: "progress",
                        width: 4,
                        labelColor: "#666666",
                        startAngle: 0.75,
                        endAngle: 0.25,
                        startNumber: 0,
                        endNumber: 100,
                        labelFormat: "",
                        splitLine: {
                            fixRadius: 0,
                            splitNumber: 10,
                            width: 15,
                            color: "#FFFFFF",
                            childNumber: 5,
                            childWidth: 5
                        },
                        pointer: {
                            width: 15,
                            color: "auto"
                        }
                    }
                }
            },
            opts: {
                color: ["#FAC858", "#EE6666", "#73C0DE", "#3CA272", "#FC8452", "#9A60B4", "#ea7ccc"],
                padding: [5, 5, 0, 5],
                enableScroll: false,
                legend: { show: false, },
                fontColor: "#ffffff",
                fontSize: 12,
                xAxis: {
                    fontColor: "#ffffff",
                    fontSize: 12,
                    disableGrid: true
                },
                yAxis: {
                    fontColor: "#ffffff",
                    fontSize: 12,
                    gridType: "dash",
                    dashLength: 2
                },
                extra: {
                    column: {
                        type: "group",
                        width: 10,
                        activeBgColor: "#000000",
                        activeBgOpacity: 0.08,
                        seriesGap: 2,
                        categoryGap: 3,
                        barBorderCircle: false,
                        linearType: "none",
                        linearOpacity: 1,
                        colorStop: 0,
                        meterBorder: 1,
                        meterFillColor: "#FFFFFF",
                        labelPosition: "outside"
                    },
                    area: {
                        type: "curve",
                        opacity: 0.2,
                        addLine: true,
                        width: 2,
                        gradient: true,
                        activeType: "hollow"
                    }
                }
            }


        };
    },
    mounted: function () {
        // 初始数据加载
        setTimeout(() => {
            this.onlineUsers = 1258;
            this.salesToday = 25680;
        }, 1000);

        // 定时更新数据
        setInterval(() => {
            this.updateNumbers();
            this.getIndexData();
        }, 60000);

        this.getIndexData();
        this.getColumnData();
        // this.setCpuLoading();
        // setInterval(() => {
        //     this.setCpuLoading();
        // }, 5000);
    },
    methods: {

        setCpuLoading() {
            let cpu = Math.floor(Math.random() * (50 - 10 + 1)) + 10;
            let memory = Math.floor(Math.random() * (50 - 10 + 1)) + 10;
            console.log(cpu);
            console.log(memory);

            let ress = {
                categories: [{ "value": 0.2, "color": "#1890ff" }, { "value": 0.8, "color": "#2fc25b" }, { "value": 1, "color": "#f04864" }],
                series: [
                    {
                        name: "完成率",
                        data: cpu / 100
                    }
                ]
            };
            let resa = {
                categories: [{ "value": 0.2, "color": "#1890ff" }, { "value": 0.8, "color": "#2fc25b" }, { "value": 1, "color": "#f04864" }],
                series: [
                    {
                        name: "完成率",
                        data: memory / 100
                    }
                ]
            };
            this.opts_cup.title.name = cpu + "%";
            this.opts_memory.title.name = memory + "%";
            this.cpuData = JSON.parse(JSON.stringify(ress));
            this.memoryData = JSON.parse(JSON.stringify(resa));
        },

        //screen/getIndexData
        getIndexData() {
            let that = this;
            that.axios
                .post("/screen/getIndexData")
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        that.jsonData = res.data;
                        console.log(that.jsonData);
                        let ress = {
                            categories: [{ "value": 0.2, "color": "#1890ff" }, { "value": 0.8, "color": "#2fc25b" }, { "value": 1, "color": "#f04864" }],
                            series: [
                                {
                                    name: "完成率",
                                    data: res.data.cpu
                                }
                            ]
                        };
                        let resa = {
                            categories: [{ "value": 0.2, "color": "#1890ff" }, { "value": 0.8, "color": "#2fc25b" }, { "value": 1, "color": "#f04864" }],
                            series: [
                                {
                                    name: "完成率",
                                    data: res.data.memory
                                }
                            ]
                        };
                        console.log(that.opts_cup.title.name);
                        that.opts_cup.title.name = res.data.cpu + "%";
                        that.opts_memory.title.name = res.data.memory + "%";
                        this.cpuData = JSON.parse(JSON.stringify(ress));
                        this.memoryData = JSON.parse(JSON.stringify(resa));
                        const absNum = Math.abs(res.data.view);
                        // 转为字符串后拆分为数组，再映射为数字
                        that.viewData = String(absNum).split('').map(Number);
                    }
                });
        },

        getColumnData() {
            let that = this;
            that.axios
                .post("/screen/getColumnData")
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        that.oneData = res.data.one;
                        let re1 = {
                            categories: res.data.data1.categories,
                            series: [
                                {
                                    name: "科目",
                                    data: res.data.data1.data,
                                    itemStyle: {
                                        // 直接为每个柱子指定颜色
                                        color: ['#5470C6', '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#5470C6', '#91CC75', '#FAC858', '#EE6666', '#73C0DE']
                                    }
                                }
                            ]
                        };
                        this.chartData = JSON.parse(JSON.stringify(re1));
                        let re2 = {
                            categories: res.data.data2.categories,
                            series: [
                                {
                                    name: "科目",
                                    data: res.data.data2.data,
                                    itemStyle: {
                                        // 直接为每个柱子指定颜色
                                        color: ['#5470C6', '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#5470C6', '#91CC75', '#FAC858', '#EE6666', '#73C0DE']
                                    }
                                }
                            ]
                        };
                        this.chartData2 = JSON.parse(JSON.stringify(re2));
                        let re3 = {
                            categories: res.data.data3.categories,
                            series: [
                                {
                                    name: "科目",
                                    data: res.data.data3.data,
                                    itemStyle: {
                                        // 直接为每个柱子指定颜色
                                        color: ['#5470C6', '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#5470C6', '#91CC75', '#FAC858', '#EE6666', '#73C0DE']
                                    }
                                }
                            ]
                        };
                        this.chartData3 = JSON.parse(JSON.stringify(re3));
                        let re4 = {
                            categories: res.data.data4.categories,
                            series: [
                                {
                                    name: "科目",
                                    data: res.data.data4.data,
                                    itemStyle: {
                                        // 直接为每个柱子指定颜色
                                        color: ['#5470C6', '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#5470C6', '#91CC75', '#FAC858', '#EE6666', '#73C0DE']
                                    }
                                }
                            ]
                        };
                        this.chartData4 = JSON.parse(JSON.stringify(re4));
                    }
                });
        },


        getServerData() {
            //模拟从服务器获取数据时的延时
            setTimeout(() => {
                //模拟服务器返回数据，如果数据格式和标准格式不同，需自行按下面的格式拼接
                let res = {
                    categories: ["1月", "2月", "3月", "4月", "5月", "6月"],
                    series: [
                        {
                            name: "月份",
                            data: [35, 8, 25, 37, 4, 20]
                        }
                    ]
                };
                this.chartData = JSON.parse(JSON.stringify(res));
            }, 500);
        },

        updateNumbers() {
            // 随机增加一些数值
            this.onlineUsers += Math.floor(Math.random() * 50) + 10;
            this.salesToday += Math.floor(Math.random() * 2000) + 500;
        },

    },
};
</script>
<style>
::v-deep .custom-progress .el-progress-bar__outer {
    background-color: transparent !important;
}

.qiu {
    background: url(https://www.yitku.com/screen/pao.png) no-repeat center center;
    background-size: 100%;
    width: 260px;
    height: 140px;
    margin-bottom: 20px;
}

.content1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

/* 定一个旋转动画 用于实现波浪效果 */
@keyframes progressRotate {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.content1 .progress-box {
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -webkit-mask-image: -webkit-radial-gradient(white, black);
    width: 133px;
    height: 133px;
}

/* 设置进度条样式 */
.content1 .progress-box .progress {
    position: absolute;
    /* 波浪占据外层圆形区域的百分比 由 --progress控制 */
    top: calc(100% - var(--progress));
    left: -46px;
    z-index: 9;
    width: 266px;
    height: 266px;
    border-radius: 42%;
    background: linear-gradient(#227ee0, #13469e);
    /* 添加旋转动画效果 */
    animation: progressRotate 8.5s linear infinite;
    /* 由于上面使用了transform 且动画中也使用了transform 设置该属性使其叠加生效 */
    animation-composition: add;
}

/* 设置进度数字样式 */
.content1 .progress-box .progress-value-p {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 100%;
}

.content1 .progress-box .progress-value-p .value {
    font-size: 24px;
    font-weight: bold;
    color: rgb(255, 255, 255);
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.content1 .progress-box .progress-value-p .value span {
    font-size: 12px;
}

.content1 .progress-box .progress-value-p .text {
    font-size: 12px;
    color: #FFFFFF;
    line-height: 20px;
}

body {
    padding: 0;
    margin: 0;
}

.stat-item {
    margin: 20px 0;
    padding: 15px;
    background-color: rgba(10, 25, 41, 0.6);
    border-radius: 6px;
}

.stat-label {
    font-size: 18px;
    margin-right: 15px;
    color: #ccc;
}

button {
    margin-top: 20px;
    padding: 10px 20px;
    background-color: #00f0ff;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}

button:hover {
    background-color: #00c8e6;
}



body {
    background: url('https://www.yitku.com/screen/s_bg.jpg') no-repeat center top;
    background-size: cover;
}

.header {
    background: url('https://www.yitku.com/screen/s_head.png') no-repeat center top;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.header .h_title {
    font-weight: bold;
    font-size: 40px;
    color: #FFFFFF;
    text-shadow: 0px 9px 23px rgba(9, 35, 51, 0.21);
    letter-spacing: 10px;
    line-height: 112px;
}

.header .h_time {
    font-weight: 500;
    font-size: 19px;
    color: #FFFFFF;
    line-height: 52px;
    display: flex;
    align-items: center;
    flex-direction: row;
}

.header .h_time img {
    margin-right: 15px;
}


.b_body {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

}

.b_body .b_left {
    width: 25%;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
}


.b_body .b_left .hot {
    width: 390px;
    background: rgba(32, 67, 218, 0.2);
    border: 1px solid #78A4DC;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
}

.b_body .b_left .hot .four {
    display: flex;
    flex-direction: row;
}

.b_body .b_left .hot .hot_title {
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 34px;
    padding: 0 20px;
    margin-bottom: 10px;
}

.b_body .b_left .hot .hot_title span {
    width: 5px;
    height: 5px;
    background: linear-gradient(149deg, #00FFE3, #00BDF3);
    border-radius: 50%;
    display: inline-block;
    margin-right: 10px;
}

.b_body .b_left .hot .four_body {
    width: 360px;
}

.b_body .b_left .hot .four .four1 {
    width: 14px;
    height: 14px;
    border-top: 2px solid #10E4E5;
    border-left: 2px solid #10E4E5;
}

.b_body .b_left .hot .four .four2 {
    width: 14px;
    height: 14px;
    border-top: 2px solid #10E4E5;
    border-right: 2px solid #10E4E5;
}

.b_body .b_left .hot .four .four3 {
    width: 14px;
    height: 14px;
    border-bottom: 2px solid #10E4E5;
    border-left: 2px solid #10E4E5;
}

.b_body .b_left .hot .four .four4 {
    width: 14px;
    height: 14px;
    border-bottom: 2px solid #10E4E5;
    border-right: 2px solid #10E4E5;
}

.b_body .hot_ucharts {
    width: 370px;
    height: 210px;
    margin: 0 10px;
}

.b_body .hot_uchartb {
    width: 370px;
    height: 204px;
    margin: 0 10px;
}

.b_body .hot_content {
    display: flex;
    flex-direction: column;
    padding: 5px 20px;
}

.b_body .hot_content .hot_li {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
}

.hot_jt {
    width: 20px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.hot_name {
    width: 100px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    color: #FFFFFF;
}

.hot_rang {
    width: 228px;
}

.b_body .b_center {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
}

.b_body .b_center .price {
    display: flex;
    flex-direction: column;
    width: 440px;
    height: 160px;
    text-align: center;
    margin-top: 70px;
    background: url('https://www.yitku.com/screen/b_price.png') no-repeat center top;
    background-size: cover;
}

.b_body .b_center .price .b_nav {
    font-weight: bold;
    font-size: 19px;
    color: #FFFFFF;
    text-shadow: 0px 2px 4px rgba(38, 23, 6, 0.1);
    line-height: 49px;
}

.b_body .b_center .price .b_price {
    font-weight: bold;
    font-size: 54px;
    color: #FFFFFF;
    text-shadow: 0px 2px 4px rgba(38, 23, 6, 0.1);
    background: linear-gradient(0deg, rgba(16, 228, 229, 0.78) 0%);
    line-height: 120px;
}

.b_body .b_center .b_title {
    font-size: 26px;
    color: #FFFFFF;
    line-height: 50px;
    margin: 70px 0 20px 0;
    letter-spacing: 5px;
}

.b_body .b_center .b_time {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.b_body .b_center .b_li {
    width: 60px;
    height: 90px;
    color: #fff;
    font-size: 44px;
    background: url(https://www.yitku.com/screen/num.png) no-repeat center top;
    background-size: cover;
    margin: 0 15px;
    line-height: 82px;
    text-align: center;
    font-weight: bold;
}

.b_body .b_left {
    width: 25%;
}


.b_body .u_list {
    width: 590px;
    height: 120px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 20px 0;
}

.b_body .u_list .u_left {
    width: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.b_body .u_list .u_left .u_text {
    display: flex;
    flex-direction: column;
}

.b_body .u_list .u_left .u_img {
    margin-right: 10px;
}

.b_body .u_list .u_left .u_text .u_num {
    font-weight: 800;
    font-size: 30px;
    color: #10E4E5;
}

.b_body .u_list .u_left .u_text .u_num span {
    font-size: 30px;
    color: #10E4E5;
    margin-left: 5px;
}

.b_body .u_list .u_left .u_text .u_txt {
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 34px;
}

.screen {
    position: relative;
}

.datai {
    background: url(https://www.yitku.com/screen/ai.png) no-repeat center top;
    background-size: contain;
    width: 100%;
    height: 250px;
    position: absolute;
    bottom: 0;
}

.cpu {
    width: 950px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.cpu .cpu_left {
    width: 240px;
    height: 270px;
    background: url(https://www.yitku.com/screen/memory.png) no-repeat center 90px;
    background-size: contain;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.cpu .cpu_chart {
    width: 130px;
    height: 130px;
}

.cpu .cpu_right {
    width: 240px;
    height: 270px;
    background: url(https://www.yitku.com/screen/memory.png) no-repeat center 90px;
    background-size: contain;
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>